export default __webpack_public_path__ + "static/main-page-bg-25c0f3af90e73fc4b6a25c42fc92e5a7.jpg";